// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import DropdownComponentController from './dropdown_component_controller';
import FlashComponentController from '../../components/flash_component/flash_component_controller';
import CheckoutController from './checkout';
import FormSubmitController from './form_submit_controller';
import HiddenTimezoneFieldController from './hidden_timezone_field_controller';

import SidebarComponentController
  from '../../components/admin/sidebar_component/sidebar_component_controller';
import MobileSidebarButtonComponentController
  from '../../components/admin/mobile_sidebar_button_component/mobile_sidebar_button_component_controller';
import BottomNavComponentController
  from '../../components/admin/sidebar_component/bottom_nav_component_controller';

import QueryFormController from './query_form_controller';

import WebauthnRegisterController from './webauthn/register_controller';
import WebauthnAuthenticationController from './webauthn/authentication_controller';

import RedirectController from './redirect_controller';

import HomeController from './home_controller';
import SlideshowController from './slideshow_controller';

import TurnstileComponentController from '../../components/cloudflare/turnstile_component_controller';

import ModalController from './modal_controller';

application.register('dropdown-component', DropdownComponentController);
application.register('flash-component', FlashComponentController);
application.register('checkout', CheckoutController);
application.register('form-submit', FormSubmitController);
application.register('hidden-timezone-field', HiddenTimezoneFieldController);

application.register('sidebar-component', SidebarComponentController);
application.register('mobile-sidebar-button-component', MobileSidebarButtonComponentController);
application.register('bottom-nav-component', BottomNavComponentController);

application.register('query-form', QueryFormController);

application.register('webauthn--register', WebauthnRegisterController);
application.register('webauthn--authentication', WebauthnAuthenticationController);

application.register('redirect', RedirectController);

application.register('home', HomeController);
application.register('slideshow', SlideshowController);

application.register('turnstile-component', TurnstileComponentController);

application.register('modal', ModalController);
